export *  from "Math/ParametricCurve";

export class Position2 {
    constructor(public x: number, public y: number) {}
    add(p: Position2): Position2;
    add(s: Size2): Position2;
    add(p: any) {
        if (typeof(p) == 'Position2') {
            return new Position2(this.x + p.x, this.y + p.y);
        }
        else if(typeof(p) == 'Size2') {
            return new Position2(this.x + p.width, this.y + p.height);
        }
        else {
            throw("Can't add " + typeof(p) + " to Position2");
        }
    }
}
export class Vec2 {
    constructor(public x1: number, public x2: number) {}
    add(v: Vec2) {
        return new Vec2(this.x1 + v.x1, this.x2 + v.x2);
    }
}
export class Size2 {
    constructor(public width: number, public height: number) {}
}

export class Box {
    topLeft: Position2;
    bottomRight: Position2;
    top() { return this.topLeft.y }
    left() { return this.topLeft.x }
    right() { return this.bottomRight.x }
    bottom() { return this.bottomRight.y }
    constructor(left: number, top: number, right: number, bottom:number);
    constructor(topLeft: Position2, bottomRight: Position2);
    constructor(...args: any[]) {
        if (args[0] instanceof Position2) {
            this.topLeft = args[0],
            this.bottomRight = args[1]
        }
        else {
            this.topLeft = new Position2(args[0], args[1]),
            this.bottomRight = new Position2(args[2], args[3])
        }
    }
    subset(b2: Box): Box {
        return Box.subset(this, b2);
    }
    static subset(b1: Box, b2: Box): Box {
        return new Box(
            new Position2(
                Math.max(b1.topLeft.x, b2.topLeft.x),
                Math.max(b1.topLeft.y, b2.topLeft.y)
            ),
            new Position2(
                Math.min(b1.bottomRight.x, b2.bottomRight.x),
                Math.min(b1.bottomRight.y, b2.bottomRight.y)
            )
        )
    }
}	




// WEBPACK FOOTER //
// ./src/code/Math/Geometry.ts